import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Link } from "react-router-dom";
import { TableRow, TableCell, IconButton, Tooltip, Typography, Box } from "@mui/material";
import { Edit, Reorder, CheckCircle, Cancel, Group } from "@mui/icons-material";

const SortableChallenge = ({ id, challenge }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-US').format(num);
  };

  return (
    <TableRow
      ref={setNodeRef}
      style={style}
      sx={{ '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' } }}
    >
      <TableCell {...listeners} sx={{ cursor: 'grab' }}>
        <Reorder />
      </TableCell>
      <TableCell>
        <Typography>{challenge.challenge_title}</Typography>
      </TableCell>
      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Group sx={{ color: 'text.secondary' }} />
          <Typography>{formatNumber(challenge.total_joins)}</Typography>
        </Box>
      </TableCell>
      <TableCell>
        <Typography>{challenge.total_sessions ?? 0}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography
          sx={{
            color: challenge.challenge_is_active === 1 ? 'green' : 'red',
            fontWeight: 500,
          }}
        >
          {challenge.challenge_is_active === 1 ? 'Active' : 'Inactive'}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Tooltip title="Edit">
          <IconButton component={Link} to={`/challenges/edit/${challenge.challenge_id}`}>
            <Edit />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default SortableChallenge;